<!--<div class="login-container">
  <form [formGroup]="loginForm" (ngSubmit)="login()">
    <mat-form-field>
      <mat-label>Email</mat-label>
      <input matInput formControlName="email">
    </mat-form-field>
    <mat-form-field>
      <mat-label>Password</mat-label>
      <input matInput type="password" formControlName="password">
    </mat-form-field>
    <button mat-raised-button color="primary" type="submit">Login</button>
  </form>
</div>-->



<!DOCTYPE html>
<html>

<head>
  <title>Login Diary</title>
  <meta name="viewport" content="width=device-width, initial-scale=1">
  <!--webfonts-->
  <link href='https://fonts.googleapis.com/css?family=Roboto:400,100,300,500,700,900' rel='stylesheet' type='text/css'>
  <!--/webfonts-->


</head>
  <body>

    <!--<h1>Welcome!<span>Please login...</span></h1>-->
    <h1>Muhammad Shafi Advocate</h1>
    <div class="login-box">
      <form [formGroup]="loginForm" (ngSubmit)="login()">
        <input type="text" class="text" matInput formControlName="email" value="Username" onfocus="this.value = '';" onblur="if (this.value == '') {this.value = 'Username';}">
        <input type="password" value="Password" matInput formControlName="password" onfocus="this.value = '';" onblur="if (this.value == '') {this.value = 'Password';}">

        <!--<div class="remember">
          <a href="#"><p>Remember me</p></a>
          <h4>Forgot your password?<a href="#">Click here.</a></h4>
        </div>-->
        <div class="clear"> </div>
        <div class="btn2">
          <input type="submit" value="LOG IN">
        </div>
      </form>
      <div class="clear"> </div>
    </div>
  </body>
</html>


